// src/Dashboard/pages/user/Galleries/components/PhotoSkeleton.jsx

import React from "react";

export default function PhotoSkeleton() {
  return (
    <div className="overflow-hidden rounded-[24px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-950">
      <div
        className="animate-pulse bg-slate-200 dark:bg-slate-800"
        style={{ aspectRatio: "16 / 9" }}
      />

      <div className="flex items-center justify-between gap-3 p-3">
        <div className="h-3 w-2/3 animate-pulse rounded bg-slate-200 dark:bg-slate-800" />
        <div className="h-9 w-20 animate-pulse rounded-2xl bg-slate-200 dark:bg-slate-800" />
      </div>
    </div>
  );
}